const jQ = jQuery.noConflict();

class CircularLoader {
    constructor(progressBar, openArticle, activeTab, singleProdOver) {
		this.progressBar = progressBar;
		this.openArticle = openArticle;
		this.activeTab = activeTab;	
		this.singleProdOver = singleProdOver;	
    }
    init(arg) {
		const singleProdOver = document.querySelector(this.singleProdOver);
		const openArticle = document.querySelector(this.openArticle);
		let activeTab;

		if (openArticle) {
			activeTab = openArticle.querySelector(this.activeTab);
		}
		else if (singleProdOver) {
			activeTab = singleProdOver.querySelector(this.activeTab);
		}
		if(activeTab) {
			const progressBar = activeTab.querySelector('.progress-bar-outer');
			const circleGoal = progressBar.getAttribute("data-circle-goal");
			const circleMax = progressBar.getAttribute("data-circle-max");
			const percent = circleGoal / circleMax;
			const angleEnd = percent * 360;
			let angleStart;
			if(arg) {
				angleStart = (Number(arg['counter-cal']) / circleMax) * 360;
			}
			else {
				angleStart = 0;
			}
			// animating the circular motion
			jQ({deg: angleStart}).animate({deg: angleEnd},
				{
				duration: 3000,
				step: function(now) {
					jQ(progressBar).find(".spinner").css({
						transform: 'rotate(' + now + 'deg)'
					});
					if(Math.floor(now) >= 180){
						jQ(progressBar).find(".filler").css("opacity", 1);
						jQ(progressBar).find(".mask").css("opacity", 0);
					}
				}
			});
		}
    }
}

export default new CircularLoader('.progress-bar-outer', 'article.is-open', '.tab-item.is-active', '.single-prod-over.is-active');